import { useServices } from '@/components/Services';
import { type UseQueryOptions, type UseQueryResult, useQuery } from 'react-query';
import { QUERY_KEYS } from '@/utils/queryKeys';
import { captureException } from '@sentry/react';
import type { ViewEstablishments } from '@enmon/commons/lib/enmon';
import type { GetEstablishmentsArg, GetEstablishmentsResult } from '@/services/api/establishments/types';

export const useEstablishments = <TView extends ViewEstablishments = ViewEstablishments.Default>(
  filter: GetEstablishmentsArg,
  view: TView,
  options: UseQueryOptions<GetEstablishmentsResult<TView>> = {},
): UseQueryResult<GetEstablishmentsResult<TView>> => {
  const { establishmentsApiClient } = useServices();

  return useQuery({
    queryKey: QUERY_KEYS.establishments.filter(filter, view),
    queryFn: async ({ signal }) => await establishmentsApiClient.get<TView>(filter, view, signal),
    onError: error => {
      console.error(error);
      captureException(error);
    },
    ...options,
  });
};
